if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('[data-country-search-results]'),
        };
        if (!this.elements.input || !this.elements.button || !this.elements.panel) return;
        this.initialized = true;
        this.onDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
        this.onPanelWheel = this.lockPanelWheel.bind(this);
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('pointerdown', this.rememberButtonState.bind(this));
        this.elements.button.addEventListener('click', this.toggleSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      connectedCallback() {
        if (!this.initialized) return;
        document.addEventListener('pointerdown', this.onDocumentPointerDown);
        this.elements.panel.addEventListener('wheel', this.onPanelWheel, { passive: false });
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        document.removeEventListener('pointerdown', this.onDocumentPointerDown);
        this.elements.panel.removeEventListener('wheel', this.onPanelWheel);
      }

      lockPanelWheel(event) {
        if (this.elements.panel.hasAttribute('hidden')) return;

        const hoveredScroller = event.target.closest('.disclosure__list');
        const scroller = this.elements.panel.contains(hoveredScroller)
          ? hoveredScroller
          : this.elements.panel.querySelector('.disclosure__list');

        event.preventDefault();
        if (!scroller) return;

        const deltaMultiplier = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? scroller.clientHeight : 1;
        scroller.scrollTop += event.deltaY * deltaMultiplier;
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer')?.classList.remove('country-selector-open');
        if (this.header) this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus?.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus?.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        const selectedCurrency = event.currentTarget.dataset.currency;
        const isNavbarCountrySelection = ['HeaderCountryForm', 'HeaderCountryFlagForm', 'HeaderCountryMobileForm'].includes(
          form?.id
        );
        const currencyPrompt = document.querySelector('h7-currency-recommendation');

        if (
          isNavbarCountrySelection &&
          selectedCurrency &&
          currencyPrompt?.promptForCountrySelection({
            countryCode: event.currentTarget.dataset.value,
            countryName:
              event.currentTarget.dataset.countryName ||
              event.currentTarget.querySelector('.country')?.textContent?.trim(),
            currency: selectedCurrency,
          })
        ) {
          this.hidePanel();
          return;
        }

        if (selectedCurrency) {
          try {
            window.localStorage.setItem('h7-selected-currency', selectedCurrency);
          } catch (_error) {
            // Currency selection still submits when storage is unavailable.
          }
        }
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector(event) {
        event?.preventDefault();
        this.isOpening = true;
        document.querySelectorAll('localization-form').forEach((form) => {
          if (form !== this && typeof form.hidePanel === 'function') form.hidePanel();
        });
        this.elements.button.focus();
        this.elements.panel.removeAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', 'true');
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          if (this.header) this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer')?.classList.add('country-selector-open');
        requestAnimationFrame(() => {
          this.isOpening = false;
        });
      }

      rememberButtonState() {
        this.buttonWasExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
      }

      handleDocumentPointerDown(event) {
        if (this.elements.button.getAttribute('aria-expanded') === 'true' && !this.contains(event.target)) {
          this.hidePanel();
        }
      }

      toggleSelector(event) {
        event?.preventDefault();
        const shouldClose = this.buttonWasExpanded || this.elements.button.getAttribute('aria-expanded') === 'true';
        this.buttonWasExpanded = false;
        if (shouldClose) {
          this.hidePanel();
          this.elements.button.focus();
          return;
        }
        this.openSelector();
      }

      closeSelector(event) {
        if (this.isOpening) return;
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          (event.relatedTarget && !this.contains(event.relatedTarget))
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
